import base from './base.repository';
export default {
    ...base,
    saveSubscription(payload){
        return this.post('subscriptions', payload);
    },
    getSubscriptions(userId){
        return this.get(`subscriptions?user=${userId}`);
    }
}


// WEBPACK FOOTER //
// ./src/repositories/subscriptions.repository.js